import React, { useState } from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { connect, useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../_metronic";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import { logout } from "../../crud/auth.crud";
import { actions } from "../../store/ducks/auth.duck";

function UserProfile({ me, showHi, showAvatar }) {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      dispatch(actions.logout());
    }
  };

  if (!me.identity?.adm_name) handleLogout();

  const getInitials = (name) => {
    if (!name) return "AD";
    const parts = name.split(" ");
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <Dropdown
      className="kt-header__topbar-item kt-header__topbar-item--user"
      drop="down"
      alignRight
      onToggle={(nextShow) => setIsOpen(nextShow)}
    >
      <Dropdown.Toggle
        as={HeaderDropdownToggle}
        id="dropdown-toggle-user-profile"
      >
        <div className="kt-header__topbar-user" style={{ display: "flex", alignItems: "center" }}>
          {showHi && (
            <span className="kt-header__topbar-username kt-hidden-mobile">
              {me.identity?.adm_name}
            </span>
          )}

          {showAvatar && (
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: "50%",
                backgroundColor: "#5867dd",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontWeight: "bold",
                fontSize: 12,
                marginLeft: showHi ? "8px" : "0",
              }}
            >
              {getInitials(me.identity?.adm_name)}
            </div>
          )}

          <i
            className="fas fa-chevron-down kt-hidden-mobile"
            style={{
              marginLeft: "8px",
              fontSize: "10px",
              transition: "transform 0.2s ease",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
        <div
          className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
          style={{
            backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-5.jpg")})`,
          }}
        >
          <div className="kt-user-card__name">{me.identity?.adm_name}</div>
        </div>

        <div className="kt-notification">
          <div
            className="kt-notification__custom"
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <Link to="/seguranca" className="btn btn-outline-primary btn-bold">
              <i className="fas fa-shield-alt mr-1"></i> Segurança
            </Link>
            <button onClick={handleLogout} className="btn btn-primary btn-bold">
              Sair
            </button>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

const mapStateToProps = ({ auth: { me } }) => ({ me });

export default connect(mapStateToProps)(UserProfile);
